/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h6[_ngcontent-%COMP%]{margin:0}td.balance[_ngcontent-%COMP%]{width:55px;font-size:18px;text-align:right}.muted[_ngcontent-%COMP%]{color:#eee}"];
export { styles as styles };
